'use client';

import { Image } from '@doist/marketist';
import { Box } from 'app/components/marketist';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { CompanyLogo } from 'components/company-logo/company-logo';
import { useLocale } from 'next-intl';
import { PublicationQuote } from './publication-quote/publication-quote';
import { PublicationQuotes } from './publication-quote/publication-quotes';
import css from './customer-logos-section.module.css';
import Interpolate from '@/components/Interpolate/Interpolate';
export function CustomerLogosSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  return <Box className={cn(css.customerLogosContainer, 'pbs-32 xlg-pbs-128 pbe-128 xlg-pbe-192')} data-sentry-element="Box" data-sentry-component="CustomerLogosSection" data-sentry-source-file="customer-logos-section.tsx">
            <Image className={css.backgroundImage} src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/home/customer-logos-bg@2x.png`} width={1512} height={332} alt="" data-sentry-element="Image" data-sentry-source-file="customer-logos-section.tsx" />
            <PublicationQuotes data-sentry-element="PublicationQuotes" data-sentry-source-file="customer-logos-section.tsx">
                <PublicationQuote key="verge" quote={<Interpolate t={t} i18nKey={'publicationQuotes.theVerge'} />} logo={<CompanyLogo logo={{
        id: 'v1715868560/the-verge_gdh1dw',
        width: 92,
        height: 16
      }} />} data-sentry-element="PublicationQuote" data-sentry-source-file="customer-logos-section.tsx" />
                <PublicationQuote key="pcmag" shape="square" quote={<Interpolate t={t} i18nKey={'publicationQuotes.pcMag'} />} logo={<CompanyLogo logo={{
        id: 'v1715868560/pc-mag_ak9mna',
        width: 30,
        height: 40
      }} />} data-sentry-element="PublicationQuote" data-sentry-source-file="customer-logos-section.tsx" />
                <PublicationQuote key="techradar" quote={<Interpolate t={t} i18nKey={'publicationQuotes.techRadar'} />} logo={<CompanyLogo logo={{
        id: 'v1715868560/techradar_qt0nt6',
        width: 120,
        height: 18
      }} />} data-sentry-element="PublicationQuote" data-sentry-source-file="customer-logos-section.tsx" />
            </PublicationQuotes>
        </Box>;
}